export function Debounce<T extends Function>(fn: T, wait: number): T {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn.apply(this, args);
        }, wait);
    } as unknown as T;
}
